import { styled } from '../../../styled';
import { Theme } from '../../../theme/interface/detailed';
import { Button } from '../../buttons';

export const SendButton = styled(Button)(({ theme, isOffline }: { theme: Theme; isOffline: boolean }) => {
	return isOffline
		? theme.offlineChat.buttons.startConversationButton
		: theme.prechat.buttons.startConversationButton;
});
